import DesktopMenuTextKeys from '../sportsbook-desktop-menu-text-keys';
import {
	trackSportsbookOpenQuickLinkCustom,
	trackSportsbookOpenQuickLinkLeague,
	trackSportsbookOpenQuickLinkSport
} from '@comeon/analytics';
import { useTypedTranslations } from '../../../../../translation/use-translations';
import useQueryExploreQuickLinks from '~/components/sportsbook/lobby/queries/quick-links/use-query-quick-links';

import { QuickLinkTypeDto } from '~/components/sportsbook/lobby/api/sbapi/sbapi-api-model';
import { MenuHeader, MenuHeaderLabel, MenuList, MenuListItem, MenuWrapper } from './sportsbook-desktop-menu-layout';

const SportsbookDesktopMenuQuickLinks = () => {
	const { translate, isLoadingTranslations } = useTypedTranslations(DesktopMenuTextKeys);
	const { data: quickLinks, isError, isPending } = useQueryExploreQuickLinks();

	if (isPending || isLoadingTranslations) {
		return null;
	}

	// No Quick links
	if (isError || quickLinks.length === 0) {
		return null;
	}

	return (
		<MenuWrapper>
			<MenuHeader>
				<MenuHeaderLabel>{translate(DesktopMenuTextKeys.FEATURED_LINKS_LABEL)}</MenuHeaderLabel>
			</MenuHeader>
			<MenuList>
				{quickLinks.map((quickLink, i) => (
					<MenuListItem
						onClick={() => {
							switch (quickLink.type) {
								case QuickLinkTypeDto.SPORT:
									trackSportsbookOpenQuickLinkSport(
										i + 1,
										quickLink.labelName,
										quickLink.id,
										quickLink.sportId,
										quickLink.sportName
									);
									break;
								case QuickLinkTypeDto.LEAGUE:
									trackSportsbookOpenQuickLinkLeague(
										i + 1,
										quickLink.labelName,
										quickLink.id,
										quickLink.leagueId,
										quickLink.leagueName
									);
									break;
								case QuickLinkTypeDto.CUSTOM:
									trackSportsbookOpenQuickLinkCustom(
										i + 1,
										quickLink.labelName,
										quickLink.id,
										quickLink.url
									);
									break;
								default:
							}
						}}
						key={quickLink.id}
						sportIcon={quickLink.icon}
						title={quickLink.labelName}
						to={quickLink.url}
					/>
				))}
			</MenuList>
		</MenuWrapper>
	);
};

export default SportsbookDesktopMenuQuickLinks;
